//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "CardMini",
  props: [
    'title',
    'url',
    'date',
    'announce',
    'image',
  ]
}
